import styled from '@emotion/styled';
import { colors } from '@modernanimal/common';

import Fonts from '../fonts';
import Icons from '../icons';

type Props = {
  label: string;
  checked: boolean;
  onClick: ()=> void;
};

const CheckBoxButton = ({
    label, checked, onClick
}: Props) => {
    const MedicalRecordsFont = Fonts.LabelMedium;
    return (
        <MedicalRecordButton style={{ backgroundColor: checked ? colors.WHITE : colors.KIOSK_GREY }} onClick={onClick}>
            <MedicalRecordsFont
                style={{ color: checked ? colors.GREY_1 : colors.GREY_2 }}
            >
                {label}
            </MedicalRecordsFont>
            <div style={{ marginLeft: 10 }}>
                {checked ? (
                    <Icons.CircleCheck height={24} width={24} fill={colors.GREEN} />
                ) : (
                    <EmptyCircle />
                )}
            </div>
        </MedicalRecordButton>
    );
};

export default CheckBoxButton;

const MedicalRecordButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid ${colors.PERIWINKLE_5};
  padding: 12px 16px;
  text-align: left;
`;

const EmptyCircle = styled.div`
  display: flex;
  height: 22px;
  width: 22px;
  border-radius: 12px;
  border: 1px solid ${colors.PERIWINKLE_4};
`;
